var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaunch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_412_6652)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 41,
    r: 32,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 29C38.383 29 33 34.383 33 41V50.535L33.445 50.832C33.578 50.92 36.792 53 45 53C53.208 53 56.422 50.92 56.555 50.832L57 50.535V41C57 34.383 51.617 29 45 29ZM45 50C40.038 50 36 45.962 36 41C36 39.145 36.505 37.983 36.924 36.983C41.124 36.561 43.968 35.234 47.005 32.208C51.718 33.614 54 37.226 54 41C54 45.962 49.962 50 45 50Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 43C41.3284 43 42 42.3284 42 41.5C42 40.6716 41.3284 40 40.5 40C39.6716 40 39 40.6716 39 41.5C39 42.3284 39.6716 43 40.5 43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5 43C50.3284 43 51 42.3284 51 41.5C51 40.6716 50.3284 40 49.5 40C48.6716 40 48 40.6716 48 41.5C48 42.3284 48.6716 43 49.5 43Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_412_6652",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_412_6652"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_412_6652",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunch);
export default __webpack_public_path__ + "static/media/launch.4ccade030248247cbd7a45f515ea8f44.svg";
export { ForwardRef as ReactComponent };